import {
  Box,
  Container,
  Typography,
  Button,
  Stack,
  Fade,
  Slide,
  Checkbox,
  CircularProgress,
} from "@mui/material";

import { Link as RouterLink } from "react-router-dom";

export default function Hero() {
  return (
    <Box sx={{ pt: { xs: 6, md: 7 }, pb: 3 }}>
      <Container
        maxWidth={false}
        sx={{
          maxWidth: "1120px",
          px: { xs: 2, sm: 2.5 },
        }}
      >
        <Box
          sx={{
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.25fr 0.75fr" },
            gap: 2.5,
          }}
        >
          {/* LEFT — HERO CARD */}
          <Slide direction="up" in timeout={600}>
            <Box
              sx={{
                position: "relative",
                overflow: "hidden",
                borderRadius: "26px",
                p: { xs: 3, md: 4 },
                border: "1px solid var(--linha)",
                background: "rgba(255,255,255,0.04)",
                boxShadow: "0 18px 60px rgba(0,0,0,0.38)",
              }}
            >
              {/* RADIAL GLOW */}
              <Box
                sx={{
                  position: "absolute",
                  inset: -2,
                  pointerEvents: "none",
                  background: `
                    radial-gradient(600px 320px at 20% 0%, rgba(18,212,122,0.25), transparent 55%),
                    radial-gradient(500px 300px at 90% 30%, rgba(26,255,122,0.18), transparent 58%)
                  `,
                  opacity: 0.9,
                }}
              />

              <Fade in timeout={900}>
                <Box sx={{ position: "relative" }}>
                  <Typography
                    sx={{
                      fontWeight: 900,
                      letterSpacing: "0.12em",
                      fontSize: 12,
                      opacity: 0.8,
                      mb: 1,
                    }}
                  >
                    PLATAFORMA DE INGRESSOS
                  </Typography>

                  <Typography
                    variant="h2"
                    sx={{
                      fontWeight: 900,
                      letterSpacing: "-0.02em",
                      lineHeight: 1.05,
                      mb: 1.5,
                      fontSize: { xs: 36, sm: 42, md: 48, lg: 54 },
                    }}
                  >
                    Ingressos para eventos com{" "}
                    <Box component="span" sx={{ color: "var(--verdeClaro)" }}>
                      até 3x sem juros
                    </Box>
                  </Typography>

                  <Typography
                    sx={{
                      maxWidth: "56ch",
                      opacity: 0.78,
                      lineHeight: 1.6,
                      mb: 3,
                    }}
                  >
                    Compre ingressos com transparência. Organize eventos com
                    controle e segurança — com experiência profissional do
                    início ao fim.
                  </Typography>

                  {/* CTAs */}
                  <Stack direction="row" spacing={1.5} flexWrap="wrap">
                    <Button
                      component={RouterLink}
                      to="/organizadores"
                      variant="outlined"
                      sx={{
                        px: 2.5,
                        py: 1.2,
                        borderRadius: "14px",
                        fontWeight: 900,
                      }}
                    >
                      Sou organizador
                    </Button>

                    <Button
                      component={RouterLink}
                      to="/eventos"
                      variant="text"
                      sx={{
                        px: 2.5,
                        py: 1.2,
                        borderRadius: "14px",
                        fontWeight: 900,
                        color: "rgba(255,255,255,0.9)",
                        "&:hover": {
                          background: "rgba(255,255,255,0.06)",
                        },
                      }}
                    >
                      Ver eventos
                    </Button>
                  </Stack>
                </Box>
              </Fade>
            </Box>
          </Slide>

          {/* RIGHT — STATS */}
          <Box sx={{ display: "grid", gap: 1.5 }}>
            {[
              {
                title: "Pix, Crédito e Débito",
                desc: "Pagamento simples e rápido no checkout.",
              },
              {
                title: "Taxas claras",
                desc: "Taxa exibida no checkout — sem surpresas.",
              },
              {
                title: "Infra financeira ONURB Finance",
                desc: "Repasses e conciliação com governança.",
              },
            ].map((item, idx) => (
              <Slide
                key={item.title}
                direction="up"
                in
                timeout={600 + idx * 120}
              >
                <Box
                  sx={{
                    border: "1px solid var(--linha)",
                    background: "rgba(255,255,255,0.04)",
                    borderRadius: "18px",
                    p: 2,
                  }}
                >
                  <Typography sx={{ fontWeight: 900, fontSize: 18, mb: 0.5 }}>
                    {item.title}
                  </Typography>
                  <Typography
                    sx={{
                      fontSize: 13,
                      fontWeight: 600,
                      opacity: 0.7,
                    }}
                  >
                    {item.desc}
                  </Typography>
                </Box>
              </Slide>
            ))}
          </Box>
        </Box>
      </Container>
    </Box>
  );
}
